<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-form>
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              note_add
            </v-icon>
            <h3 class="title ml-2">
              Create bridge signing
            </h3>
            <v-spacer />
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />

          <v-card-text>
            <v-container
              grid-list-md
              class="pa-0"
            >
              <v-layout
                wrap
                class="form-group"
              >
                <v-flex xs12>
                  <h6 class="subheading">
                    Bridge Signing details
                  </h6>
                </v-flex>

                <v-flex
                  xs12
                  md12
                >
                  <label class="radio-label">Investment type</label>
                  <v-radio-group
                    v-model="formData.investtype"
                    row
                    @change="investtypeUpdate"
                  >
                    <v-radio
                      v-for="investtype in investmentTypes"
                      :key="investtype"
                      :value="investtype"
                      :label="investtype"
                      color="primary"
                    />
                  </v-radio-group>
                </v-flex>

                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="formData.investsum"
                    label="Invest sum"
                    :error-messages="getFieldErrors('investsum')"
                    @input="$v.formData.investsum.$touch()"
                    @blur="$v.formData.investsum.$touch()"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="formData.user_id"
                    label="User id"
                    :error-messages="getFieldErrors('user_id')"
                    @input="$v.formData.user_id.$touch()"
                    @blur="$v.formData.user_id.$touch()"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="formData.contract_id"
                    label="Contract id"
                    :error-messages="getFieldErrors('contract_id')"
                    @input="$v.formData.contract_id.$touch()"
                    @blur="$v.formData.contract_id.$touch()"
                  />
                </v-flex>

                <v-flex
                  md6
                  xs12
                >
                  <v-menu
                    v-model="pickerDateOpen"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formData.contract_accepted_at"
                        label="Document date"
                        prepend-icon="event"
                        readonly
                        :error-messages="getFieldErrors('contract_accepted_at')"
                        v-on="on"
                        @change="$v.formData.contract_accepted_at.$touch()"
                        @blur="$v.formData.contract_accepted_at.$touch()"
                      />
                    </template>
                    <v-date-picker
                      v-model="formData.contract_accepted_at"
                      :max="todaysDate"
                      show-current
                      color="info"
                      @change="pickerDateOpen = false"
                    />
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
            <v-alert
              v-if="error"
              :value="error"
              type="error"
              color="error"
            >
              {{ error }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              Cancel
            </v-btn>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isLoading || !$v.formData.$anyDirty"
                  :loading="isLoading"
                  color="primary"
                  @click="submit"
                  v-on="on"
                >
                  <span>Create Bridge Signing</span>
                </v-btn>
              </template>
              <span>Validate and submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { investmentTypes } from '@/enum/bridgeSigning/BridgeSigningEnum';

export default {
  name: 'CreateBridgeSigningDialog',

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    pickerDateOpen: false,
    error: null,
    investmentTypes,
    todaysDate: new Date().toISOString().substr(0, 10),
    formData: {
      user_id: null,
      contract_id: null,
      investtype: investmentTypes.PREPAY,
      investsum: null,
      contract_accepted_at: null,
    },
  }),

  validations() {
    return {
      formData: {
        user_id: { required }, // '70248',
        contract_id: { required }, //  '1',
        investtype: { required }, // 'prepay',
        investsum: { required }, // '250',
        contract_accepted_at: { required }, // '2019-09-30',
      },
    };
  },
  computed: {
    validFields() {
      return Object.keys(this.$v.formData.$params).filter(
        item => !this.$v.formData[item].$invalid,
      );
    },
    errors() {
      return Object.keys(this.$v.formData.$params).filter(
        item => this.$v.formData[item].$invalid,
      );
    },
  },

  methods: {
    getFieldErrors(field) {
      const errors = [];
      if (this.$v.formData[field]) {
        if (!this.$v.formData[field].$dirty || !this.$v.formData[field].$invalid) {
          return errors;
        }

        if (!this.$v.formData[field].required) {
          errors.push('Required field');
        }
      }

      return errors;
    },
    investtypeUpdate(value) {
      this.formData.investtype = value;
    },
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isLoading = true;
        this.$store
          .dispatch('createBridgeSigning', this.formData)
          .then(() => {
            this.onToggleOpen();
          })
          .catch((err) => {
            this.error = err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" >
.create-bridge-signing {
  .v-card__title {
    padding: 24px;
  }
  .v-card__text {
    max-height: 65vh;
    overflow: auto;
    padding-top: 32px;
  }
  .v-card__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .radio-label {
    position: absolute;
    font-size: 16px;
    text-align: left;
    max-width: 133%;
    height: 20px;
    left: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.54);
    -webkit-transform: translateY(-18px) scale(0.75);
    transform: translateY(0px) translateX(-6px) scale(0.75);
  }
  .subheading {
    padding: 8px;
    background: white;
    color: rgba(0, 0, 0, 0.54);
    top: -20px;
    left: 8px;
    position: absolute;
    display: flex;
    align-items: center;
  }
  .form-group {
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
  }
  .container.grid-list-md .layout:not(:only-child) {
    margin: 0 0 24px 0;
  }
  .v-input--selection-controls.v-input .v-label {
    text-transform: capitalize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bridgeSigning/dialog/CreateBridgeSigning.vue